export default __webpack_public_path__ + "static/media/s3.3c44db61.jpg";